/**
 * Identifica o ambiente do browser pela hostname.
 *
 * `isLocalhost()` é usado para suprimir comportamentos de produção que
 * incomodariam em desenvolvimento local — ex.: modal "Nova versão
 * disponível" do heartbeat (AAWZ-WEB-3VT) não deve aparecer quando o
 * frontend está rodando contra Flask local, porque o versao.json local
 * frequentemente fica desatualizado entre builds de teste.
 *
 * Hosts considerados localhost:
 *  - localhost
 *  - 127.0.0.1
 *  - 0.0.0.0
 *  - *.local.com.br (whitelabel local, ex.: whitelabel.aawz.local.com.br)
 *
 * Tudo o mais — dev.aawz.com.br, whitelabelh.aawz.com.br, app.aawz.com.br,
 * etc. — é considerado ambiente remoto (modal deve aparecer normalmente).
 */
export const APP_VARIANT_BETA = 'beta'
export const APP_VARIANT_PROD = 'prod'
export const APP_VARIANT_LOCAL = 'local'

/**
 * Identifica qual variante do bundle está rodando: 'beta' | 'prod' | 'local'.
 *
 * A distinção beta/prod vem do BASE_URL inlined no build (vue.config.js
 * publicPath): o bundle beta é servido de /static/vue-frontend-beta e o
 * estável de /static/vue-frontend. Serve para segmentar telemetria
 * (Sentry/Loki/GA) entre a versão beta (feature flag) e a estável.
 *
 * Os parâmetros existem só para teste — em runtime os defaults de
 * process.env são inlined pelo webpack.
 */
export function getAppVariant({ nodeEnv, baseUrl } = {}) {
  const env = nodeEnv !== undefined ? nodeEnv : process.env.NODE_ENV
  if (env !== 'production') return APP_VARIANT_LOCAL
  const base = baseUrl !== undefined ? baseUrl : process.env.BASE_URL || ''
  if (base.includes('vue-frontend-beta')) return APP_VARIANT_BETA
  return APP_VARIANT_PROD
}

export function isLocalhost(hostname) {
  const host =
    typeof hostname === 'string'
      ? hostname
      : typeof window !== 'undefined' && window.location
      ? window.location.hostname
      : ''
  if (!host) return false
  if (host === 'localhost' || host === '127.0.0.1' || host === '0.0.0.0') {
    return true
  }
  return host.endsWith('.local.com.br')
}
